import React from "react";

import { NARRATIVE_TYPES_ARRAY, getNarrativeSlug } from "posts/constants";

import { getNarrativeTypeColor } from "utils/styles";

export default function NarrativeSVGGradients() {
  const gradients = NARRATIVE_TYPES_ARRAY.map((narrativeType) => {
    const slug = getNarrativeSlug(narrativeType);

    return [
      <linearGradient
        id={`gradient-${slug}`}
        key={slug}
        x1="0"
        x2="0"
        y1="0"
        y2="1"
      >
        <stop
          offset="10%"
          stopColor={getNarrativeTypeColor(narrativeType)}
          stopOpacity="0.9"
        />
        <stop
          offset="100%"
          stopColor={getNarrativeTypeColor(narrativeType)}
          stopOpacity="0"
        />
      </linearGradient>,
      <linearGradient
        id={`gradient-${slug}-highlighted`}
        key={`${slug}-highlighted`}
        x1="0"
        x2="0"
        y1="0"
        y2="1"
      >
        <stop
          offset="10%"
          stopColor={getNarrativeTypeColor(narrativeType)}
          stopOpacity="0.9"
        />
        <stop
          offset="100%"
          stopColor={getNarrativeTypeColor(narrativeType)}
          stopOpacity="0.9"
        />
      </linearGradient>,
    ];
  });

  return <defs>{gradients}</defs>;
}
